import Api from '../Base'

class GetSpaceAssignmentByCycleId extends Api {
  requestUrl = `/api/SpaceAssignment/${this.getParams().id}/Cycle`
}

export default GetSpaceAssignmentByCycleId
